/**
 * @fileoverview CopyToClipboard Component
 *
 * Copy to clipboard interaction
 */

import SelectorEngine from '../../utils/dom/selector-engine';
import SnackbarNotification from '../SnackbarNotification'; // copytoclip.js

/**
 * https://github.com/zenorocha/clipboard.js
 */
const copyToClipboard = () => {
	const copytoclipboardElements = SelectorEngine.find('.js-copytoclipboard');

	if (copytoclipboardElements.length > 0) {
		import('clipboard').then(({ default: ClipboardJS, NamedExport })=> {
			copytoclipboardElements.forEach((element) => {
				const notificationWrapper = SelectorEngine.findOne('.js-notification', element);
				const button = SelectorEngine.findOne('.js-copytoclipboard-button', element);

				const notification = new SnackbarNotification(notificationWrapper, {});
				const clipboard = new ClipboardJS(button);

				clipboard.on('success', function() {
					notification.open();
				});

				clipboard.on('error', function() {
					// TODO: to be handle later on
				});
			});
		});
	}
}


const globalCopyToClipboard = copyToClipboard();

export default globalCopyToClipboard;
